<div class="page-viewer" data-testid="drawing-set-page-viewer">
  <header class="viewer-header">
    <h2 class="viewer-title">Page {{ row.page_number }}@if (row.number) { · {{ row.number }} }@if (row.title) { · {{ row.title }} }</h2>
    <div class="viewer-tools">
      <div class="mode-chips" role="group" aria-label="Preview">
        <button type="button" class="mode-chip" [class.mode-chip--on]="zoom === 1" [attr.aria-pressed]="zoom === 1" data-testid="drawing-set-viewer-whole"
          (click)="showWholePage()">Whole page</button>
        <button type="button" class="mode-chip" [class.mode-chip--on]="titleBlockZoom" [attr.aria-pressed]="titleBlockZoom" data-testid="drawing-set-viewer-title-block"
          (click)="showTitleBlock()">Title block</button>
      </div>
      <button type="button" mat-icon-button aria-label="Close" data-testid="drawing-set-viewer-close" (click)="close()"><mat-icon>close</mat-icon></button>
    </div>
  </header>
  <!-- W66: the map's zoom stack over the scroller, bottom-right (the chips keep Whole page / Title block) -->
  <div class="scroll-shell">
  <div #scroller class="viewer-scroll" [class.viewer-scroll--zoomed]="zoom > 1" data-testid="drawing-set-viewer-scroll"
    (wheel)="onWheel($event)" (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)" (pointercancel)="onPointerUp($event)"
    (lostpointercapture)="onCaptureLost()" (gesturestart)="onGestureStart($event)" (gesturechange)="onGestureChange($event)" (gestureend)="onGestureEnd($event)">
    @if (row.preview_url || row.thumb_url) {
      <img class="viewer-image" [style.width.%]="zoom * 100" [src]="row.preview_url || row.thumb_url" [alt]="'Page ' + row.page_number" draggable="false"
        data-testid="drawing-set-viewer-image" />
      <!-- Item 9: zoomed in, the page drawn sharp from the set PDF, over the enlarged preview once it is ready -->
      <div #sharpHost class="viewer-sharp" [hidden]="!sharpZoom || sharpZoom !== zoom" [style.width.px]="sharpBox?.width" [style.height.px]="sharpBox?.height"></div>
    } @else {
      <p class="viewer-empty mat-body-1">The page preview shows here once the page is inspected.</p>
    }
  </div>
  <app-sheet-zoom-controls testIdPrefix="drawing-set-viewer" [zoom]="zoom" [canZoomIn]="!titleBlockZoom" [canZoomOut]="zoom > 1"
    (zoomIn)="zoomBy(1)" (zoomOut)="zoomBy(-1)" />
  </div>
</div>
